/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export class MonitoringUrl {
    private static readonly SENSOR_URL_PREFIX = 'https://ee-check.easd/monitor/datapoint/link/byurn/';

    private readonly sensorName: string | null;

    constructor(sensorName: string | null) {
        this.sensorName = sensorName;
    }

    getUrl(): string | null {
        return this.sensorName
            ? `${MonitoringUrl.SENSOR_URL_PREFIX}${this.sensorName}`
            : null;
    }
}
